/* Keep a quote brief in this tab only; the customer submits the contact form. */
(function () {
  const key = 'dec-delivery-quote-yards-v2';
  function brief(lines, country, catalog, shipping) {
    if (!Array.isArray(lines) || !lines.length || lines.length > 200) return null;
    if (lines.some(line => !line || line.handle !== 'print-your-own-fabric' ||
      typeof line.title !== 'string' || !Object.hasOwn(catalog, line.title) ||
      !Number.isSafeInteger(line.quantity) || line.quantity < 1)) return null;
    const result = shipping.weight(lines, catalog);
    if (!result) return null;
    return ['Please quote fabric printing and delivery.', '',
      ...lines.map(line => `${line.title}: ${line.quantity} yard(s)`), '',
      `Fabric net weight: ${result.netKg.toFixed(4)} kg`,
      `Estimated packaging: ${result.packagingKg.toFixed(4)} kg`,
      `Estimated packed weight: ${result.packedKg.toFixed(4)} kg`,
      `Delivery country: ${country || '[please enter]'}`,
      'Delivery postcode: [please enter]', '',
      'Please confirm availability, shipping, volume-weight adjustments, taxes and any additional charges before payment.'].join('\n');
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {brief};
  if (typeof document === 'undefined') return;
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-dec-delivery-quote]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const destination = new URL(link.href, location.href);
    if (destination.origin !== location.origin) return;
    const root = link.closest('[data-dec-pyo], dec-fabric-shipping');
    if (!root || !window.DECFabricCatalog || !window.DECFabricShipping) return;
    let lines, country = '';
    const cart = root.querySelector('[data-dec-cart-data]');
    if (cart) {
      try { lines = JSON.parse(cart.textContent).lines; } catch (_) { return; }
      const choice = root.querySelector('select');
      if (choice?.value) country = choice.selectedOptions[0]?.textContent || '';
    } else {
      const base = root.querySelector('[data-dec-base]');
      const quantity = root.querySelector('[data-dec-quantity]');
      lines = [{handle:'print-your-own-fabric', title:base?.selectedOptions[0]?.dataset.name, quantity:Number(quantity?.value)}];
    }
    const text = brief(lines, country, window.DECFabricCatalog, window.DECFabricShipping);
    try {
      sessionStorage.removeItem(key);
      if (!text) return;
      sessionStorage.setItem(key, JSON.stringify({text, created:Date.now()}));
      destination.hash = 'dec-delivery-quote';
      link.href = destination.href;
    } catch (_) { /* The contact link still works when storage is unavailable. */ }
  });
  if (location.hash !== '#dec-delivery-quote') return;
  const message = document.querySelector('[data-dec-quote-message]');
  if (!message || message.value.trim()) return;
  try {
    const saved = JSON.parse(sessionStorage.getItem(key));
    if (!saved || typeof saved.text !== 'string' || saved.text.length > 30000 ||
      !Number.isFinite(saved.created) || Date.now() - saved.created > 30 * 60 * 1000 || saved.created > Date.now()) return;
    message.value = saved.text;
    message.dispatchEvent(new Event('input', {bubbles:true}));
    sessionStorage.removeItem(key);
    message.closest('form')?.scrollIntoView({block:'start'});
  } catch (_) { /* Keep the ordinary contact form usable. */ }
}());
